export const getOpeningStatus = (ranges, type) => {

  let isOpen = null;
  let msg = '';
  let msg2 = '';
  let nextTime = '';
  
  // @TODO Hacky way to manage translations -> TO BE FIXED
  //  eslint-disable-next-line
  const lang = typeof drupalSettings === 'undefined' ? 'fr' : drupalSettings.path.currentLanguage;

  const currentDate = new Date(); // Current date and time
  //const currentDate = new Date('2023-12-12T18:24:00'); // Current date and time
  const currentDateString = currentDate.toISOString().split('T')[0]; // Get the current date in the format "YYYY-MM-DD"


  for (let i = 0; i < ranges.length; i++) {
    const range = ranges[i];
    const startDate = range.startDate;
    const endDate = range.endDate;

    let timeString = ranges[i].startTime;
    let [hours, minutes, seconds] = timeString.split(":");
    const startTime = new Date(currentDate.getTime());
    startTime.setHours(hours);
    startTime.setMinutes(minutes);
    startTime.setSeconds(seconds);

    timeString = ranges[i].endTime;
    [hours, minutes, seconds] = timeString.split(":");
    const endTime = new Date(currentDate.getTime());
    endTime.setHours(hours);
    endTime.setMinutes(minutes);
    endTime.setSeconds(seconds);

    // Get the range based on dates only
    if (currentDateString >= startDate && currentDateString <= endDate) {
      
      // Check the time
      if (currentDate >= startTime && currentDate <= endTime) {
        isOpen = true;
        nextTime = endTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        if (lang == 'nl'){
          msg = type == "CLOSED" ? 
          "Open tot" :
          "Toegankelijk voor het publiek tot"
        }else{
          msg = type == "CLOSED" ? 
          "Ouvert jusqu'à" :
          "Accessible au public jusqu'à"
        }
        
      }else{
        isOpen = false;
        // If now is the last day of a range, we need the following range to know the new opening time
        // So we check if (now == end). If true, we use the opening time of the next range
        if (currentDateString == endDate){
          nextTime = ranges[i].startTime.slice(0, -3);
        }else{
          nextTime = startTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        }
        if (lang == 'nl'){
          msg = type == "CLOSED" ? 
                      "Gesloten" + '.' :
                      "Niet toegankelijk" + '.'
          msg2 = type == "CLOSED" ? 
                      "Open om" :
                      "Toegankelijk vanaf"
        }else{
          msg = type == "CLOSED" ? 
                      "Fermé" + '.' :
                      "Non accessible" + '.'
          msg2 = type == "CLOSED" ? 
                      "Ouvre à" :
                      "Accessible au public à partir de"
        }
      }

      break;
    }
  }
  return {
    'isOpen': isOpen,
    'nextTime': nextTime,
    'msg': msg,
    'msg2': msg2,
    
  };
}
